import { Controller } from '@hotwired/stimulus'

/*
 * Calculadora de la cuota en la ficha de una hipoteca
 * (`opinables/hipotecas/_calculadora`): recalcula la cuota con y sin bonificaciones
 * para el importe y el plazo de los dos controles.
 *
 * La fórmula es la de `Hipoteca.calcular_cuota` (sistema francés): si cambia allí,
 * cambia aquí. El servidor ya pinta las cuotas del importe y el plazo de partida,
 * así que sin JS la ficha enseña las mismas cifras que antes.
 */
const EUROS = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', useGrouping: 'always' })
const EUROS_SIN_DECIMALES = new Intl.NumberFormat('es-ES', {
  style: 'currency', currency: 'EUR', maximumFractionDigits: 0, useGrouping: 'always'
})

export function calculaCuota (importe, plazoAnyos, interesAnual) {
  const meses = 12 * plazoAnyos
  if (!interesAnual) return importe / meses

  const interesMensual = interesAnual / 100 / 12
  const multiplicador = (1 + interesMensual) ** meses
  return importe * ((interesMensual * multiplicador) / (multiplicador - 1))
}

export default class extends Controller {
  static targets = ['importe', 'plazo', 'importeTexto', 'plazoTexto', 'cuotaCon', 'cuotaSin']
  static values = { interesCon: Number, interesSin: Number }

  calcula () {
    const importe = Number(this.importeTarget.value)
    const plazo = Number(this.plazoTarget.value)

    this.importeTextoTarget.textContent = EUROS_SIN_DECIMALES.format(importe)
    this.plazoTextoTarget.textContent = `${plazo} años`
    this.cuotaSinTarget.textContent = EUROS.format(calculaCuota(importe, plazo, this.interesSinValue))
    if (this.hasCuotaConTarget) {
      this.cuotaConTarget.textContent = EUROS.format(calculaCuota(importe, plazo, this.interesConValue))
    }
  }
}
